import { useToast, chakra, Button } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';
import { createSenderID } from '../../../API/account/senderId';
import { toaster } from '../../../utils/toast';
import FormInput from '../../UI/form/FormInput';
import { createDomain } from '../../../API/account/domains';

const CreateDomain: FC<{ close: () => void }> = ({ close }) => {
  const [domainName, setDomainName] = useState('');

  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(createDomain, {
    onSuccess(data) {
      const success = { ...data }
      toaster(toast, success)
      queryClient.invalidateQueries(['domainData']);
      close && close();
    },

    onError(data: any) {
      const errors = { ...data };
      toaster(toast, errors)
    },
  });

  return (
    <chakra.form
      onSubmit={(e) => {
        e.preventDefault();

        mutate({ domainName });
      }}
      marginTop={"20px"}
    >
      <FormInput
        label='Add Domain'
        type='text'
        for='Domain'
        tag='Add yours or you can use our default domain'
        formControlProps={{
          isRequired: true,
        }}
        inputProps={{
          placeholder: 'Bodsquare.com',
          onChange: (e) => {
            setDomainName(e.target.value);
          },
          // max: '11',
          // isInvalid: name?.length > 11,
        }}
        helperText={`mywebsite.com, don't include "http://" or "https://"`}
      />

      <Button
        isLoading={isLoading}
        // isDisabled={!name || name?.length > 11}
        w='full'
        colorScheme={'primary'}
        mt='32px'
        mb='40px'
        type='submit'
      >
        Add Domain
      </Button>
    </chakra.form>
  );
};

export default CreateDomain;
